if (!customElements.get("models-page")) {
  class ModelsPage extends HTMLElement {
    constructor() {
      super();
      this.scrollFrame = null;
      this.handleScroll = () => this.requestTabUpdate();
      this.handleClick = (event) => this.onClick(event);
      this.handleDocumentChange = (event) => this.onFilterChange(event);
      this.handleFilterReset = () => {
        if (this.filterAll) this.filterAll.checked = true;
      };
      this.handleDrawerOpen = (event) => this.updateFilterExpanded(event, true);
      this.handleDrawerClosed = (event) => this.updateFilterExpanded(event, false);
    }

    connectedCallback() {
      this.tabs = [...this.querySelectorAll("[data-models-tab]")];
      this.categories = [...this.querySelectorAll("[data-models-category]")];
      this.filterButton = this.querySelector('[aria-controls="drawer-filters"]');
      this.filterAll = document.querySelector("#drawer-filters [data-models-filter-all]");
      this.filterOptions = [
        ...document.querySelectorAll("#drawer-filters [data-models-filter-option]"),
      ];
      this.filterReset = document.querySelector("#drawer-filters [data-filters-reset]");

      this.addEventListener("click", this.handleClick);
      document.addEventListener("change", this.handleDocumentChange);
      this.filterReset?.addEventListener("click", this.handleFilterReset);
      window.addEventListener("scroll", this.handleScroll, { passive: true });
      window.addEventListener("resize", this.handleScroll, { passive: true });
      window.addEventListener("drawerOpen", this.handleDrawerOpen);
      window.addEventListener("drawerClosed", this.handleDrawerClosed);
      this.updateActiveTab();
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.handleClick);
      document.removeEventListener("change", this.handleDocumentChange);
      this.filterReset?.removeEventListener("click", this.handleFilterReset);
      window.removeEventListener("scroll", this.handleScroll);
      window.removeEventListener("resize", this.handleScroll);
      window.removeEventListener("drawerOpen", this.handleDrawerOpen);
      window.removeEventListener("drawerClosed", this.handleDrawerClosed);
      if (this.scrollFrame) window.cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = null;
    }

    onClick(event) {
      const target = event.target instanceof Element ? event.target : null;
      const tab = target?.closest("[data-models-tab]");
      if (!tab || !this.contains(tab) || !tab.hash) return;

      const section = document.querySelector(tab.hash);
      if (!section) return;

      event.preventDefault();
      this.setActiveTab(section.id);
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    onFilterChange(event) {
      const target = event.target instanceof HTMLInputElement ? event.target : null;
      if (!target || !this.filterAll) return;

      if (target === this.filterAll) {
        const selectedOptions = this.filterOptions.filter((option) => option.checked);

        if (!target.checked && selectedOptions.length === 0) {
          target.checked = true;
          return;
        }

        if (target.checked) {
          selectedOptions.forEach((option) => {
            option.checked = false;
            option.dispatchEvent(new Event("change", { bubbles: true }));
          });
        }
        return;
      }

      if (this.filterOptions.includes(target)) {
        this.filterAll.checked = !this.filterOptions.some((option) => option.checked);
      }
    }

    requestTabUpdate() {
      if (this.scrollFrame) return;

      this.scrollFrame = window.requestAnimationFrame(() => {
        this.scrollFrame = null;
        this.updateActiveTab();
      });
    }

    updateActiveTab() {
      let activeId = "models-list";
      const marker = 100;
      const visibleCategories = this.categories.filter(
        (category) => category.getClientRects().length > 0,
      );

      this.tabs.forEach((tab) => {
        if (tab.hash === "#models-list") return;

        const category = this.categories.find((item) => tab.hash === `#${item.id}`);
        tab.hidden = !category || !visibleCategories.includes(category);
      });

      visibleCategories.forEach((category) => {
        if (category.getBoundingClientRect().top <= marker) activeId = category.id;
      });

      this.setActiveTab(activeId);
    }

    setActiveTab(activeId) {
      this.tabs.forEach((tab) => {
        if (tab.hash === `#${activeId}`) tab.setAttribute("aria-current", "location");
        else tab.removeAttribute("aria-current");
      });
    }

    updateFilterExpanded(event, expanded) {
      if (event.detail?.id !== "drawer-filters" || !this.filterButton) return;

      this.filterButton.setAttribute("aria-expanded", String(expanded));
      if (!expanded) this.requestTabUpdate();
    }
  }

  customElements.define("models-page", ModelsPage);
}
